var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.2895 5.4832L3.84915 14.7165C2.31757 15.372 2.32665 16.2833 3.56999 16.6897L9.16667 18.5532L11.3081 25.5571C11.5684 26.3237 11.4401 26.6277 12.1947 26.6277C12.777 26.6277 13.0353 26.3445 13.3597 26.0065C13.5659 25.7912 14.7905 24.5211 16.1579 23.1029L21.9795 27.6914C23.0507 28.3218 23.8242 27.9952 24.091 26.63L27.9124 7.41933C28.3036 5.74599 27.3144 4.98697 26.2895 5.4832ZM10.045 18.1251L22.66 9.63469C23.2897 9.22726 23.8671 9.44631 23.393 9.89525L12.5913 20.292L12.1708 25.0774L10.045 18.1251Z","fill":"#8291A4"}));
}

Icon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
